import React from 'react'
import FJLocalStore from '../../../store/FJLocalStore'
import FJFilterIntensity from './FJFilterIntensity'
import FJFilterItem from './FJFilterItem'
import FJFilterCommon from "./FJFilterCommon";

function FJFilterView(props) {

  const maxCountInLine = 5;
  const {
    intensity,
    selectedType,
    onFilterChange,
    onFilterActiveChange,
    onIntensityChange,
    filters,
    filterActive,
    applyToAll,
    renderFilterToUrl
  } = props;

  let views = filters.map(item => {
    let {type, name} = item;
    return <FJFilterItem key={type}
                         type={type}
                         name={FJLocalStore._(name)}
                         renderFilterToUrl={renderFilterToUrl}
                         active={type === selectedType}
                         onClick={onFilterChange}/>
  });
  let index = filters.findIndex(item => item.type === selectedType);
  if (index > 0) {
    let insertIndex = (Math.floor(index / maxCountInLine) + 1) * maxCountInLine;
    views.splice(insertIndex, 0, <FJFilterIntensity key='intensity'
                                                    disabled={!filterActive}
                                                    value={intensity}
                                                    onChange={onIntensityChange}
    />)
  }

  return (
    <FJFilterCommon active={filterActive}
                    applyToAll={applyToAll}
                    title={FJLocalStore._('Filter')}
                    onActiveChange={onFilterActiveChange}>
      {views}
    </FJFilterCommon>
  );
}

export default FJFilterView;